import React from 'react';

const AboutModal = ({ onClose }) => {
    return (
        <div className="fixed inset-0 bg-black/50 z-[1200] flex items-center justify-center p-4 animate-fade-in">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden relative">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                >
                    ✕
                </button>

                <div className="p-6">
                    <div className="flex items-center gap-3 mb-6">
                        <img src="/logo.png" alt="Clackbase" className="h-10 w-auto" />
                        <div>
                            <h2 className="text-2xl font-bold text-gray-800">About Clackbase</h2>
                            <span className="bg-indigo-100 text-indigo-700 text-xs font-bold px-2 py-0.5 rounded-full border border-indigo-200">
                                BETA
                            </span>
                        </div>
                    </div>

                    <div className="prose prose-sm text-gray-600 mb-6">
                        <p className="mb-3">
                            Clackbase was built to solve a simple problem: <strong>finding local chess games shouldn't be hard.</strong>
                        </p>
                        <p className="mb-3">
                            Whether you're looking for a casual meetup, a verified club tournament, or just someone to play with at a coffee shop, Clackbase connects you with the local chess community.
                        </p>
                        <p>
                            We verify clubs to ensure safe environments and help organizers reach more players.
                        </p>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-100">
                        <h3 className="font-bold text-gray-800 text-sm mb-2">Connect with the Developer</h3>
                        <p className="text-xs text-gray-500 mb-3">
                            Feel free to reach out with feedback or just to say hi!
                        </p>
                        <div className="flex gap-2">
                            <a
                                href="https://www.linkedin.com/in/danielvizcarra00/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-full bg-white border border-gray-300 text-gray-700 px-3 py-2 rounded text-sm font-medium hover:bg-gray-50 transition-colors text-center flex items-center justify-center gap-2"
                            >
                                <span className="text-[#0077b5]">in</span> Connect on LinkedIn
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutModal;
